import { defineMessage } from 'services/localization';

export const messages = {
    learnMore: defineMessage('learn_more'),
    close: defineMessage('close'),
    tryNow: defineMessage('try_now_for_days'),
    titleBillToPOMatching: defineMessage('bill_to_po_matching'),
    descriptionBillToPOMatchingPO: defineMessage('you_can_match_approved__e_control_over_spending'),
    descriptionBillToPOMatchingBill: defineMessage('match_this_bill_to_the__e_control_over_spending'),
    titleBudgetChecking: defineMessage('budget'),
    descriptionBudgetChecking: defineMessage('check_your_spending_aga_et_right_on_this_screen'),
    titleGoodsReceivedNote: defineMessage('goods_received_notes_1'),
    descriptionGoodsReceivedNote: defineMessage('track_delivery_status_w_h_goods_receieved_notes'),
};
